/* cvn-qv-scope.js - Quick view: confine the injected PDP scripts to the
   dialog, so quick-viewing one product cannot rewrite the page behind it.

   THE BUG THIS FIXES (2026-09-10, Zeus: "main page on an apparel, quick view a
   mug in the picked-for-you drawer, return to the main page and all the colour
   and size variants have an X, and all the product media squares are shown
   because the media is not filtering")

   main-product.liquid ships two inline PDP scripts (swatch availability, and
   media filtering). Both bind through the SAME shared Dawn template id:

     var SECTION = "template--<id>__main";
     function scope(){ return document.getElementById('shopify-section-'+SECTION) || document; }
     function root(){ return scope().querySelector('variant-selects') || scope(); }

   The quick view fetches a whole PDP and injects its <product-info> into the
   dialog. Dawn's preventDuplicatedIDs rewrites SECTION to "quickadd-<id>" so
   the copy cannot collide with the page - but NO element with that id is ever
   created. getElementById returns null, `|| document` takes over, and every
   lookup in the injected script resolves against the WHOLE DOCUMENT, whose
   first <variant-selects> and <media-gallery> are the MAIN PAGE'S.

   So the mug's script attaches its own change handler to the crewneck's
   picker, holding the mug's VARIANTS/NAMES/VALUES. Nothing breaks yet - which
   is why this looks unreproducible. It fires on the shopper's NEXT main-page
   variant change: markAvail runs mug data against crewneck options, no value
   matches, and every swatch is marked cvn-swx-off (the X). The media script
   loses its filter the same way and falls back to showing every image.
   Verified: control (no quick view) main colour change -> 0 swatches off;
   after a mug quick view, same click -> 16 off. Hard refresh "fixes" it only
   because it discards the stale handler.

   THE FIX: rewrite the injected scripts at preprocessHTML time so their scope
   anchor is the dialog's own product-info - which DOES exist, and is already
   named after the rewritten SECTION ("MainProduct-quickadd-<id>"). That id is
   created by the theme's own duplicate-id pass, so it needs no new markup.
   Bare document.querySelector calls (the media-gallery / variant-selects
   fallbacks further down both scripts) are scoped the same way, falling back
   to an empty fragment rather than the document, so a miss is a no-op instead
   of a leak onto the page behind.

   WHY HERE and not in main-product.liquid: that file is 103KB, and a full-file
   rewrite through the Admin API on the template every product renders from is
   a silent, expensive failure. This is a ~40-line behavioural patch on the one
   method that already exists to sanitise injected markup.

   Loaded from cvn-op-boot (head, every page) so it survives the theme's
   client-side nav, which never executes scripts arriving in swapped markup.
   Sibling of cvn-qv-availability.js - same dialog, same discipline.
*/
(function () {
  'use strict';
  if (window.__cvnQvScope) return;
  window.__cvnQvScope = true;

  // the anchor: the dialog's own <product-info>, whose id the theme's
  // preventDuplicatedIDs has already rebuilt from the rewritten SECTION
  var ROOT = "(document.getElementById('MainProduct-'+SECTION)||document.createDocumentFragment())";
  var RE_SECTION_EL = /document\.getElementById\(\s*['\"]shopify-section-['\"]\s*\+\s*SECTION\s*\)/g;
  var RE_DOC_QS = /document\.querySelector\(/g;

  function rescope(productElement) {
    if (!productElement || !productElement.querySelectorAll) return 0;
    var scripts = productElement.querySelectorAll('script');
    var n = 0;
    for (var i = 0; i < scripts.length; i++) {
      var s = scripts[i];
      var t = s.textContent;
      // non-global test on purpose: a /g/ regex carries lastIndex between calls
      if (!t || !/shopify-section-['\"]\s*\+\s*SECTION/.test(t)) continue;
      t = t.replace(RE_SECTION_EL, "document.getElementById('MainProduct-'+SECTION)");
      // querySelectorAll( does not match: the regex requires ( right after r
      t = t.replace(RE_DOC_QS, ROOT + ".querySelector(");
      s.textContent = t;
      n++;
    }
    return n;
  }

  function patch(ctor) {
    var proto = ctor && ctor.prototype;
    if (!proto || proto.__cvnQvScoped) return;
    var orig = proto.preprocessHTML;
    proto.preprocessHTML = function () {
      var ret;
      // run the theme's own pass FIRST - it is what rewrites SECTION and the
      // element ids this rescope anchors to
      if (typeof orig === 'function') ret = orig.apply(this, arguments);
      try { rescope(arguments[0]); } catch (e) { /* never block the dialog */ }
      return ret;
    };
    proto.__cvnQvScoped = true;
  }

  if (window.customElements) {
    var C = customElements.get('quick-add-modal');
    if (C) patch(C);
    else if (customElements.whenDefined) {
      customElements.whenDefined('quick-add-modal').then(function () {
        patch(customElements.get('quick-add-modal'));
      });
    }
  }
})();
